/*
  Reformats how regular (non-bundled) cart lines lay out in Zipify One Click
  Upsell's Slide Cart Drawer, to reduce vertical space per line on mobile:

  Before: title/scent/tag block, then a row with [quantity stepper | price],
  then the "Save X% with Auto-refill" button as its own full-width row below
  everything — 3 stacked rows per line.

  After: title/scent/tag block with the price moved up beside it, then one
  row with [quantity stepper | Auto-refill button] — 2 rows per line.

  OCU renders this markup itself (no theme template control over it), so
  this moves the real price block and the real subscription-button wrapper
  to their new positions (not clones — appendChild moves the actual node,
  keeping its existing event listeners/state intact), same non-invasive
  pattern as ocu-bundle-cart-grouping.js / ocu-subscription-discount-overlay.js.
*/
(function () {
  var WRAPPER_SELECTOR = '.ocu-cart-line-item-wrapper[data-key]';

  // Switching a line between one-time and subscribed (or changing its
  // delivery frequency) makes OCU regenerate the price and subscription
  // elements as brand-new nodes, still parked in their default positions —
  // but it reuses the SAME outer wrapper element. A wrapper-level "already
  // done" flag would miss this and leave the fresh nodes unmoved, so instead
  // every pass checks each element's ACTUAL current parent and only moves it
  // if it isn't already where it belongs — safe to re-run on every refresh.
  function relocate(wrapper) {
    var product = wrapper.querySelector('.ocu-cart-line-item-product');
    var priceQuantity = wrapper.querySelector('.ocu-cart-line-price-quantity');
    // OCU only adds the "-label" modifier class alongside .ocu-cart-line-price
    // when a discount/compare-at price is showing — a plain, undiscounted
    // price uses .ocu-cart-line-price alone, so matching on that base class
    // (present in both cases) keeps this working whether or not there's a discount.
    var priceLabel = wrapper.querySelector('.ocu-cart-line-price');
    var subDropdown = wrapper.querySelector('.ocu-cart-line-subscription-dropdown__wrapper');
    var discountWrapper = wrapper.querySelector('.ocu-cart-line-item-product-discount-wrapper');

    if (!product || !priceQuantity) return; // not the expected structure, leave alone

    if (priceLabel && priceLabel.parentElement !== product) {
      product.appendChild(priceLabel); // moves the real node up beside the title/variant/tag
    }
    if (subDropdown && subDropdown.parentElement !== priceQuantity) {
      priceQuantity.appendChild(subDropdown); // moves the real node into the quantity row
    }
    if (discountWrapper && priceLabel && discountWrapper.parentElement !== priceLabel) {
      priceLabel.appendChild(discountWrapper); // moves the "Cologne 3-Pack" tag chip under the price/savings
    }
  }

  function relocateAll() {
    document.querySelectorAll(WRAPPER_SELECTOR).forEach(relocate);
  }

  var debounceTimer;
  function scheduleRelocate() {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(relocateAll, 150);
  }

  document.addEventListener('DOMContentLoaded', function () {
    var observer = new MutationObserver(scheduleRelocate);
    observer.observe(document.body, { childList: true, subtree: true });

    document.addEventListener('cart:build', scheduleRelocate);
    window.addEventListener('cart_changed', scheduleRelocate);
    document.addEventListener('ajaxProduct:added', scheduleRelocate);

    scheduleRelocate();
  });
})();
